import React from "react";
import { FieldProps } from "@rjsf/utils";
import { cloneDeep } from "lodash";
import { PropertyMarketValueInput } from "../../../../../../Submissions/Fields";
import BaseFieldPreview from "./BaseFieldPreview";

const PropertyMarketValueFieldPreview = (props: FieldProps) => {
  let updatedProps = cloneDeep(props);
  if (props.name === "propertyMarketValue") {
    let assessedValueIndex: Maybe<number>;
    updatedProps = {
      ...props,
      schema: {
        ...props.schema,
        oneOf: props.schema.oneOf?.filter((option, index) => {
          const valueOption = option as { name: string };
          if (valueOption.name === "automatedAssessedValue") {
            assessedValueIndex = index;
            return false;
          }
          return true;
        }),
      },
      uiSchema: {
        ...props.uiSchema,
        oneOf: props.uiSchema?.oneOf.filter(
          (_: Record<string, unknown>, index: number) =>
            index !== assessedValueIndex,
        ),
      },
    };
  }
  const widgetPreview = <PropertyMarketValueInput {...updatedProps} />;

  return (
    <BaseFieldPreview
      widgetPreview={widgetPreview}
      {...updatedProps}
    ></BaseFieldPreview>
  );
};

export default PropertyMarketValueFieldPreview;
